<div class="check-lists-global-problem" [formGroup]="form">
  <app-select
    formControlName="gpChecklist"
    class="check-lists-global-problem__control"
    textKey="name"
    [initBy]="selectedGPChecklist"
    (callback)="handleChangeGPChecklist($event)"
    [items]="checklists"
    [nullChoice]="true"
  >
  </app-select>

  <button type="button" class="button check-lists-global-problem__button" (click)="openCreateGlobalChecklist()">+</button>

  <ui-multicombobox
    class="check-lists__control"
    textKey="name"
    defaultText="Подтип глобальной проблемы"
    name="globalProblemSubtype"
    (callback)="handleChangeSubtype($event)"
    [items]="transformedGpSubtypes | func: cloneDeep"
    [initBy]="selectedGPSubtypes"
    [nullChoice]="false"
    [isDisabled]="!selectedGPChecklist"
  >
  </ui-multicombobox>
</div>
